import NotificationsContainer from './notifications-container';

export default NotificationsContainer;
